































































import { Vue, Component, Prop } from "vue-property-decorator";
import _ from "@/boot/lodash";

@Component({
  components: {
    "brand-logo": () => import("@/components/app/global/brand/logo.vue")
  }
})
export default class SupportDepartmentGridItem extends Vue {
  // Props

  @Prop({ default: null })
  public supportDepartment!: any;

  @Prop({ default: false })
  public isLoading!: boolean;

  // Computed

  public get showSkeletons() {
    return _.isNull(this.supportDepartment);
  }

  public get isAssigned() {
    return !_.isNull(this.supportDepartment.department);
  }

  public get brand() {
    return _.get(this.supportDepartment, "brand");
  }

  public get brandName() {
    return _.get(this.supportDepartment, "brand.name", "");
  }

  public get defaultOauthClient() {
    return _.find(this.brand?.oauth_clients || [], domain => domain.default)
      ?.origin;
  }

  public get showDefaultTag() {
    if (!this.isAssigned) return false;

    return this.supportDepartment?.department?.default ?? false;
  }

  public get isPublic() {
    return this.supportDepartment?.department?.is_public ?? false;
  }
}
